import { useEffect, useRef } from "react";
import { createPortal } from "react-dom";
import { useApp } from "../provider";
import { ItemTooltipContent } from "./ItemInspector";

export default function Tooltip() {
  const { readonly, previewItem, setPreviewItem, inspectedItem, items, itemNames } = useApp();
  const tooltipRef = useRef(null);

  useEffect(() => {
    if (!previewItem) return;
    let dismissTimer;
    const dismiss = event => {
      if (!event.target.closest?.(".mc-grid--inspectable, .mc-item-tooltip, .mc-item-tooltip__portal")) setPreviewItem(null);
    };
    const onScroll = event => {
      if (event.target?.closest?.(".mc-item-tooltip__portal")) return;
      setPreviewItem(null);
    };
    const containsPoint = (rect, x, y) => rect
      && x >= rect.left && x <= rect.right && y >= rect.top && y <= rect.bottom;
    const onPointerMove = event => {
      const overAnchor = containsPoint(previewItem.rect, event.clientX, event.clientY);
      const overTooltip = containsPoint(tooltipRef.current?.getBoundingClientRect(), event.clientX, event.clientY);
      if (overAnchor || overTooltip) {
        window.clearTimeout(dismissTimer);
        dismissTimer = undefined;
      } else if (dismissTimer === undefined) {
        dismissTimer = window.setTimeout(() => setPreviewItem(null), 250);
      }
    };
    document.addEventListener("pointerdown", dismiss);
    window.addEventListener("scroll", onScroll, true);
    window.addEventListener("pointermove", onPointerMove);
    return () => {
      window.clearTimeout(dismissTimer);
      document.removeEventListener("pointerdown", dismiss);
      window.removeEventListener("scroll", onScroll, true);
      window.removeEventListener("pointermove", onPointerMove);
    };
  }, [previewItem, setPreviewItem]);

  if (!readonly || !previewItem || inspectedItem || typeof document === "undefined") return null;
  const { rect, item } = previewItem;
  const isCompact = window.innerWidth <= 520;
  const width = Math.min(isCompact ? 340 : 330, window.innerWidth - 20);
  const left = isCompact
    ? Math.max(10, (window.innerWidth - width) / 2)
    : rect.right + width + 12 < window.innerWidth
      ? rect.right + 8
      : Math.max(10, rect.left - width - 8);
  const top = Math.min(Math.max(10, rect.top), Math.max(10, window.innerHeight - 190));
  const maxHeight = Math.max(0, window.innerHeight - top - 10);
  return createPortal(
    <div ref={tooltipRef} className="mc-item-tooltip__portal" style={{ left, top, width, maxHeight }} role="tooltip" tabIndex={0}>
      <ItemTooltipContent item={item} items={items} itemNames={itemNames} />
    </div>, document.body
  );
}
